import { render, staticRenderFns } from "./OverallVesselPerformanceStatus.vue?vue&type=template&id=7581119b&scoped=true&"
import script from "./OverallVesselPerformanceStatus.vue?vue&type=script&lang=ts&"
export * from "./OverallVesselPerformanceStatus.vue?vue&type=script&lang=ts&"
import style0 from "./OverallVesselPerformanceStatus.vue?vue&type=style&index=0&id=7581119b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7581119b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VIcon,VMenu,VSwitch})
